<template>

    <div class="titletags">{{ tagslabel }}
        <div><img src="@/assets/images/clearfilter.svg" @click="fnResetFilterTag()" /></div>
    </div>
    <form @submit.prevent="fnSubmitData">
      <div class="filtertagscontainer"  v-if="isloading==false" >
              <label v-for="tag in tags" :key="tag.key" class="tagscontainer" v-bind:class="{selectedtag:currentfiltertag==tag.key}"  >
              <input type="radio"  name="currentfiltertag" :value="tag.key" v-model="$store.state.currentfiltertag" @click="currentfiltertag=tag.key"  @input="fnSubmitData" >
     
              <span>{{tag.title}}</span>
            </label>
      </div>
     
 
    </form>
    
    <img class="loadingtags" src="@/assets/images/loading.gif"  v-if="isloading==true"/>
    
    

</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"
import backendmixin from "../mixins/backendmixin.js"

// eslint-disable-next-line no-unused-vars

export default {
  name: "cmpfiltertag",
  mixins:[multilangmixin,backendmixin],
  emits:["sigfilterchanged"],
  props:["initialfiltertag"],


  data(){
      return {
                
               
            };
  },
  
  
  created(){
      //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);
      this.fnFetchTags();
      this.fnInitFromQueryString();
  },

  computed:{
     
      tagslabel(){
        return this.fnGetTranslation(this.currentlang,"tags");
      },


      currentfiltertag:{
        get(){
          return this.$store.state.currentfiltertag;
        },
        set(newvalue){
          this.$store.commit("fnSetCurrentFilterTag",newvalue);
        }
      
      },

      clearfilterlabel(){
        return this.fnGetTranslation(this.currentlang,"clearfilter");
      },


  },


  methods:{


        
        fnSetCurrentHovertag(piKey)
        {
          this.currenthovertag=piKey;

        },


        fnResetFilterTag()
        {
          this.$store.commit("fnSetCurrentFilterTag","");
          this.fnSubmitData();  
        },


        fnSubmitData(){
            this.$emit("sigfilterchanged");

        },

        fnInitFromQueryString()
        {
          let wTag=this.fnGetQueryParam("tag");
          if (wTag!=undefined)
          {
              this.currentfiltertag=wTag;
          }
          //console.log(this.currentfiltercategory);
          
        }



  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>



  
  .filtertagscontainer{
    /*background-color: gray;*/
    font-weight: bold;
    font-size: 1.2em; 
    display: flex;
    flex-flow: row wrap;

    width: fit-content;
  }





  .titletags
  {
  
    font-weight: 500;
    font-size: 1.3em;
    padding-top: 2vh; 
    display: flex;
    
    justify-content:  space-between;

  }

  .titletags div img{
    width: 25px;
    align-self: flex-end;
  }

  .titletags div img:hover{
    background-color: #ffdd00;
    border-radius: 10%;
  }
  


  /* The container */
  .tagscontainer {
    display: block;
    position: relative;
    
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-right: 1vw;
   
    
    padding: 0.3vw;
    
    
    background-color: #e6e4e4;
    
  }


 .tagscontainer:hover{
    text-decoration: none;
    background-color: #ffdd00;
    
  }

  .selectedtag{
    text-decoration: none;
    background-color: #ffdd00;
    
  }



  /* Hide the browser's default radio button */
  .tagscontainer input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
 
  .loadingtags
  {
    
    width: 3vh;
    height: 3vh;
    margin: auto;
    
  }


  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
    /*
      .titletags
      {
        width: 270px;
      }

      .filtertagscontainer{
        width: 270px;
      }
*/
      .tagscontainer {
        margin-top: 5px;
      }

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
    
    .tagscontainer {
        margin-top: 1vh;
      }
 
  }


</style>
